import React from 'react'
import SubHeader from '../components/SubHeader'
import ImageGallery from '../components/ImageGallery'

const Gallery = () => {
  return (
    <>
    <SubHeader />
    <ImageGallery />
    </>
  )
}

export default Gallery
